import { createContext, useContext } from 'react';

import type { AdminCatalogMediaApi } from '../api';
import type { CatalogMediaUploadTransport } from '../services';

export type CatalogMediaContextValue = {
  api: AdminCatalogMediaApi;
  transport: CatalogMediaUploadTransport;
};
export const CatalogMediaContext = createContext<CatalogMediaContextValue | null>(null);
export function useCatalogMediaComposition() {
  const value = useContext(CatalogMediaContext);
  if (!value) throw new Error('Catalog media must be used within CatalogMediaProvider.');
  return value;
}
